+function ($j) {
	"use strict";
	if ($j("#galleriaWithoutThumbnails").length) {
		Galleria.loadTheme('/styles/lib/galleria/galleria.classic.min.js');
		Galleria.run('#galleriaWithoutThumbnails', { thumbnails: false, lightbox: true, showInfo: false, carousel: false, wait: true });
	}
	$j("a.launch-gallery-modal").click(function (e) {

		e.preventDefault();
		$j("#galleriaWithoutThumbnails").data("galleria").openLightbox();
	});
}(window.$j);


